import * as React       from 'react';
import Box              from '@mui/material/Box';
import Button           from '@mui/material/Button';
import TextField        from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Typography       from '@mui/material/Typography';
import {
    ADD_FORM_NAME,
    EDIT_CLASS_POPUP_SAVE
}                               from 'config/config';
import {
    Controller,
    SubmitHandler,
    useForm
}                               from 'react-hook-form';
import { HttpClient, ApiError } from 'apiclient/ApiClient';
import IProfile                 from 'models/IProfile';

interface IFormInput {
    first_name: string;
};

const EditStudent = (props: {
    closePopup: ()=>void
    classId: string
    studentId: string
    studentData?: IProfile
    invalidate: ()=>void
}) => {
    const [loading, setLoading] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    const client = HttpClient();
    const { control, handleSubmit } = useForm<IFormInput>();
    const onSubmit: SubmitHandler<IFormInput> = async data => {
        setErrorMsg('');
        setLoading(true);
        try {
            await client.put(`/classes/${props.classId}/profile/${props.studentId}`, data);
            props.invalidate();
            props.closePopup();
        } catch (err) {
            if (err instanceof ApiError) {
                setErrorMsg(err.message || 'Failed to update student. Please try again.');
            } else {
                setErrorMsg('An unexpected error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    return(
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <Box display='flex' sx={{
                width: '100%',
                flexDirection: 'column',
                gap: 3
            }}>
                <Controller
                    name="first_name"
                    control={control}
                    defaultValue={props.studentData?.first_name}
                    render={({field}) =>
                        <TextField
                            fullWidth
                            required
                            placeholder={ADD_FORM_NAME}
                            {...field}
                        />
                    }
                />
                {errorMsg &&
                    <Typography color='error'>{errorMsg}</Typography>
                }
                <Button
                    type='submit'
                    variant='contained'
                    fullWidth
                    disabled={loading}
                    sx={{ boxShadow: 'none' }}
                >
                    {EDIT_CLASS_POPUP_SAVE}
                </Button>
                {loading &&
                    <CircularProgress sx={{alignSelf: 'center'}}/>
                }
            </Box>
        </form>
    )
};

export default EditStudent;
